<template>
    <div class="founder">
        <div class="headline">{{ $t('headline.title5') }}</div>
        <div class="founders">
            <div class="founderItem" v-for="(item, index) in 4" :key="index">
                <div class="founderImg">
                    <img :src="`https://4d-ai.chat/img/csr${index + 1}.png`">
                </div>
                <div class="name">{{ $t(`founders.name${index + 1}`) }}</div>
                <div class="position">{{ $t(`founders.job${index + 1}`) }}</div>
                <div class="titles" v-html="$t(`founders.titles${index + 1}`)"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    mounted() {

    },
    methods: {}
}
</script>
<style scoped>
@media (max-width: 768px) {
    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .founder {
        padding: 10px 10px 0 !important;
    }

    .founderItem {
        width: 50% !important;
        margin-bottom: 10px !important;
    }

    .founders {
        flex-wrap: wrap !important;
    }

    .founderImg {
        width: 120px !important;
        height: 120px !important;
    }

    .name {
        font-size: 20px !important;
    }

    .position {
        font-size: 12px !important;
    }

    .titles {
        font-size: 10px !important;
    }
}
</style>
<style scoped lang="less">
.founder {
    background-color: #fff;
    padding: 80px 212px;
    box-sizing: border-box;

    .founders {
        display: flex;

        .founderItem:hover {
            .founderImg {
                img {
                    transform: scale(1.2);
                }
            }
        }

        .founderItem {
            width: 25%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .titles {
                font-size: 14px;
                color: #4c5563;
                text-align: center;
            }

            .position {
                font-size: 16px;
                color: #243c8a;
                margin-bottom: 12px;
            }

            .name {
                font-size: 20px;
                font-weight: bold;
                color: #243c8a;
                margin-bottom: 8px;
            }

            .founderImg {
                margin-bottom: 24px;
                width: 192px;
                height: 192px;
                overflow: hidden;
                border-radius: 50%;

                img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.6s;
                }
            }
        }
    }
}

.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 64px;
}
</style>